export const TABLE_DATA = {
  heading: "Zadara vs AWS EC2: What Changes, What Improves ",
  columns: ["AWS EC2", "Zadara (via OneMind)"],
  data: [
    {
      feature: "Billing Model",
      "AWS EC2": "Pay-per-hour/spot/savings plans",
      "Zadara (via OneMind)": "Flat-rate or usage-based (predictable)",
    },
    {
      feature: "Storage Control",
      "AWS EC2": "Tied to EBS/S3 tiers",
      "Zadara (via OneMind)": "Fully configurable (block, object, file)",
    },
    {
      feature: "Multi-Tenant Isolation",
      "AWS EC2": "VPC-level, shared backend",
      "Zadara (via OneMind)": "True tenant isolation per customer",
    },
    {
      feature: "API Compatibility",
      "AWS EC2": "AWS native",
      "Zadara (via OneMind)": "AWS-compatible + additional control",
    },
    {
      feature: "Data Residency Options",
      "AWS EC2": "Region-dependent",
      "Zadara (via OneMind)": "On-prem, cloud, or edge deployment",
    },
    {
      feature: "SLA Support & Customization",
      "AWS EC2": "Limited tuning, ticket-based",
      "Zadara (via OneMind)": "Custom SLAs + direct OneMind support",
    },
    {
      feature: "Licensing Flexibility",
      "AWS EC2": "BYOL complexity",
      "Zadara (via OneMind)": "BYOL + managed license support",
    },
  ],
};
